import { useEffect, useState } from 'react';
import { fetchPublicProfile } from '../../lib/api';
import AppStatus from '../../components/AppStatus';
import PublicProfilePage from './PublicProfilePage';

function PublicProfileByUsernamePage({ auth, username }) {
  const [state, setState] = useState({ status: 'loading', profile: null });

  useEffect(() => {
    let cancelled = false;
    setState({ status: 'loading', profile: null });
    fetchPublicProfile(username)
      .then((profile) => {
        if (cancelled) return;
        setState(profile ? { status: 'ready', profile } : { status: 'not-found', profile: null });
      })
      .catch(() => {
        if (!cancelled) setState({ status: 'error', profile: null });
      });
    return () => {
      cancelled = true;
    };
  }, [username]);

  if (state.status === 'loading') {
    return <AppStatus title="Loading profile" message="Fetching this creator's CreatorCV profile." />;
  }

  if (state.status === 'not-found') {
    return (
      <AppStatus title="Profile not found" message="This creator hasn't published a public profile yet, or this username doesn't exist." />
    );
  }

  if (state.status === 'error') {
    return (
      <AppStatus title="Something went wrong" message="Could not load this profile right now." retry={() => window.location.reload()} />
    );
  }

  return <PublicProfilePage auth={auth} publicState={state.profile} />;
}

export default PublicProfileByUsernamePage;
